import React from 'react';
import PropTypes from 'prop-types';

export default function WidgetItem({ title, titleLevel, subTitle, controls, scrollable, children, className }) {
    const scrollableAttributes = scrollable ? { tabIndex: 0 } : {};
    return (
        <div className={`widget-item ${className || ''}`}>
            <div className="no-wysiwyg widget-item__header">
                {React.createElement(
                    `h${titleLevel}`,
                    {
                        className: 'widget-item__title',
                    },
                    title
                )}
                {subTitle && <div className="widget-item__sub-title">{subTitle}</div>}
                {controls && <div className="widget-item__controls">{controls}</div>}
            </div>
            <div {...scrollableAttributes} className={`widget-item__body ${scrollable ? 'widget-item__body--scrollable' : ''}`}>
                {children}
            </div>
        </div>
    );
}

WidgetItem.propTypes = {
    title: PropTypes.string.isRequired,
    titleLevel: PropTypes.number,
    subTitle: PropTypes.string,
    controls: PropTypes.element,
    scrollable: PropTypes.bool,
};

WidgetItem.defaultProps = {
    titleLevel: 2,
    subTitle: '',
    controls: null,
    scrollable: false,
};
